import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Content, ReadOnlyForm } from '../../../fgs';
import { EditForm } from "./components";
import { readOnlyRowsSetup } from "./utils";
import { createReadOnlyForm } from "../../forms/createReadOnlyForm";
import { Button } from "reactstrap";
import * as Feather from 'react-feather';

// services
import { getUserResource, updateUserResource, RESOURCES_BASE_URL } from '../../../services/api';
import { resourceCategoryMapper } from "../../../services/selectOptions";
import { formatPathForResources } from "../../../services/urlParams";

export const EditUserResourcePage = () => {
  const { userId, resourceId } = useParams();
  const history = useHistory();
  const [showReadOnlyForm, setShowReadOnlyForm] = useState(true);
  const [showResourceMedia, setShowResourceMedia] = useState(false);
  const [form, setForm] = useState({});

  const fetchUserResource = async () => {
    await getUserResource(userId, resourceId).then((response) => {
      const attributes = response.data.data.attributes;
      attributes.categoryLabel = resourceCategoryMapper[attributes.category];


      setForm(attributes);
    });
  };

  useEffect(() => {
    fetchUserResource();
  }, []);

  const onSave = () => {
    updateUserResource(userId, resourceId, form).then(() => {
      history.push(`/dashboard/users/${userId}/profile#resources`);
    });
  };

  const toggleForms = () => {
    setShowReadOnlyForm(!showReadOnlyForm);
  };

  const formControls = [
    { title: 'Editar', props: { color: 'primary', onClick: toggleForms } },
    {
      title: 'Visualizar',
      props: {
        color: 'secondary',
        disabled: !form.path,
        onClick: () => setShowResourceMedia(true),
      }
    },
    { title: 'Voltar', props: { color: 'secondary', onClick: () => history.goBack() } }
  ];

  const renderReadOnlyForm = () => {
    if (showResourceMedia) return;

    return showReadOnlyForm
      ? <ReadOnlyForm form={createReadOnlyForm(form, readOnlyRowsSetup)} formControls={formControls} />
      : null;
  };

  const renderEditForm = () => {
    if (showResourceMedia) return;

    return !showReadOnlyForm
      ? <EditForm onSave={onSave} form={form} setForm={setForm} setShowForm={toggleForms} />
      : null;
  };

  const renderResourceMedia = () => {
    if (showResourceMedia) {
      if (form.path) {
        return <iframe
          id="iframe-resource-media"
          src={`${RESOURCES_BASE_URL}${formatPathForResources(form.path)}`} />;
      }
    }
  };

  const closeResourceMediaButton = () => {
    if (showResourceMedia) {
      const Icon = Feather.X;
      return (
        <Button
          className="btn-sm fixed-button"
          color="danger"
          onClick={() => setShowResourceMedia(false)}>
          <Icon />
        </Button>
      );
    }
  };

  return (
    <Content>
      {closeResourceMediaButton()}
      {renderEditForm()}
      {renderReadOnlyForm()}
      {renderResourceMedia()}
    </Content>
  );
};